import React from "react";
import { useTranslation } from "react-i18next";
import { useColors } from "../../constants/Colors";
import StepWrapper from "./StepWrapper";
import { SignupStore } from "../../hooks/useSignupStore";
import ImageUploader, { UploadedImage } from "../ImageUploader";

interface Props {
  store: SignupStore;
  onAuthRequired: () => void;
}

const MIN_IMAGES = 1;

const ImagesStep: React.FC<Props> = ({ store, onAuthRequired }) => {
  const { t } = useTranslation();
  const { textNeutralMuted, accentColor } = useColors();

  const profileIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="mx-auto mb-4"
      style={{ color: accentColor, opacity: 0.6 }}
    >
      <circle cx="12" cy="8" r="4"></circle>
      <path d="M20 21a8 8 0 1 0-16 0"></path>
    </svg>
  );

  return (
    <StepWrapper
      title={
        store.name
          ? `${t("signup.images.title_with_name") || "Nice to meet you"}, ${
              store.name
            }! ${t("signup.images.title_suffix") || "Add some photos"}`
          : t("signup.images.title") || "Add your profile photos"
      }
      subtitle={
        t("signup.images.subtitle") ||
        "Add at least one photo so flatmates can see who you are"
      }
    >
      <ImageUploader
        images={store.images as UploadedImage[]}
        onImagesChange={(updater) => {
          if (typeof updater === "function") {
            store.setImages(updater);
          } else {
            store.setImages(() => updater);
          }
        }}
        onRemoveImage={store.removeImage}
        kind="profile"
        minImages={MIN_IMAGES}
        maxImages={6}
        onAuthRequired={onAuthRequired}
        icon={profileIcon}
        showMainBadge={true}
      />
    </StepWrapper>
  );
};

export default ImagesStep;
